import * as Website from '../Config/Website.js';

const ACT = Website.classList.act;

const TabSwitch = () => {
  const groups = document.querySelectorAll('.js-tab-group');
  if (groups.length === 0) return;

  groups.forEach(group => {
    const btns = group.querySelectorAll('.js-tab-btn');
    const contents = group.querySelectorAll('[data-tab-content]');
    const icons = group.querySelectorAll('[data-tab-icon]');

    // アクティブなコンテンツ内のSplideをリフレッシュ
    const refreshSplide = (target) => {
      contents.forEach(el => {
        if (el.dataset.tabContent !== target) return;
        const sliders = el.querySelectorAll('.js-sliderBasic');
        sliders.forEach(slider => {
          if (slider._splide) slider._splide.refresh();
        });
      });
    };

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;

        // ボタンのアクティブ切り替え
        btns.forEach(b => b.classList.remove(ACT));
        btn.classList.add(ACT);

        // コンテンツの表示切り替え
        contents.forEach(el => {
          el.classList.toggle(ACT, el.dataset.tabContent === target);
        });

        // アイコンのアクティブ切り替え
        icons.forEach(el => {
          el.classList.toggle(ACT, el.dataset.tabIcon === target);
        });

        // Splideリフレッシュ
        refreshSplide(target);
      });

      // ホバー時にアイコンに .is-hover を付与
      btn.addEventListener('mouseenter', () => {
        const target = btn.dataset.tab;
        icons.forEach(el => {
          el.classList.toggle('is-hover', el.dataset.tabIcon === target);
        });
      });

      btn.addEventListener('mouseleave', () => {
        icons.forEach(el => el.classList.remove('is-hover'));
      });
    });
  });
};

export default TabSwitch;
